export default class sortAlphabetically {
    constructor () {
        this._sort($('.ccm-block-social-links ul li a'));
    }

    // Set up to sort Social Links in header specifically.
    // Might want to make this work with anything passed into it, but for now this works for what is needed.
    _sort (list) {
        let readyToSort = [];
        let reference = {};

        for (let i = 0; i < list.length; i++) {
            readyToSort.push(list[i].getAttribute('aria-label'));
            reference[list[i].getAttribute('aria-label')] = list[i];
        }

        // Innate JS sorting.  Sorts alphabetically, or numerically depending on what is provided.
        readyToSort.sort();
        readyToSort.push(readyToSort.splice(readyToSort.indexOf('Personal Website'), 1)[0]);

        for (let i = 0; i < readyToSort.length; i++) {
            let $li = $('.ccm-block-social-links ul li:nth-child(' + (i + 1) + ')');

            $li.append(reference[readyToSort[i]]);
            if (readyToSort[i] === 'Personal Website') {
                $li.find('a').attr('data-customName', 'GIVE'); // for styling - not accessibility
                $li.find('a').attr('aria-label', window.accessibilityText);
                $li.find('i').attr('title', window.accessibilityText);
            }
        }
    }
}
